import { h, Component } from 'preact';
import cn from 'classnames';
import styles from './content.css';

export default class Content extends Component {
	render({ children, className }) {
    const classes = cn(styles.container, className);
		return (<section className={classes}>
      {children}
		</section>);
	}
}



// WEBPACK FOOTER //
// ./components/content/content.jsx